import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { FormsModule } from '@angular/forms';
import { TagInputModule } from 'ngx-chips';
import { DatePickerModule } from '@syncfusion/ej2-angular-calendars';
import { NgbModule, NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import {NgxPaginationModule} from 'ngx-pagination';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SidemenuComponent } from './dataPitcher/sidemenu/sidemenu.component';
import { SellComponent } from './dataPitcher/sell/sell.component';
import { HomeComponent } from './dataPitcher/home/home.component';
import { SellheaderComponent } from './dataPitcher/sellheader/sellheader.component';
import { LoginComponent } from './dataPitcher/login/login.component';
import { TermconditionComponent } from './dataPitcher/termcondition/termcondition.component';
import { AssetComponent } from './dataPitcher/asset/asset.component';
import { RegisterComponent } from './dataPitcher/register/register.component';
import { OtpverifyComponent } from './dataPitcher/otpverify/otpverify.component';
import { SupportComponent } from './dataPitcher/support/support.component';
import { HelpComponent } from './dataPitcher/help/help.component';
import { UploadmodalComponent } from './dataPitcher/uploadmodal/uploadmodal.component';
import { NotificationComponent } from './dataPitcher/notification/notification.component';
import { ProfilemodalComponent } from './dataPitcher/profilemodal/profilemodal.component';
import { SellbuybuttonComponent } from './dataPitcher/sellbuybutton/sellbuybutton.component';
import { UserprofileComponent } from './dataPitcher/userprofile/userprofile.component';
import { AlgotermconditionComponent } from './dataPitcher/algotermcondition/algotermcondition.component';
import { EnginetermconditionComponent } from './dataPitcher/enginetermcondition/enginetermcondition.component';
import { SoltermconditionComponent } from './dataPitcher/soltermcondition/soltermcondition.component';
import { AlgorithmComponent } from './dataPitcher/algorithm/algorithm.component';
import { EngineComponent } from './dataPitcher/engine/engine.component';
import { SolutionComponent } from './dataPitcher/solution/solution.component';
import { StickytoolbarComponent } from './dataPitcher/stickytoolbar/stickytoolbar.component';
import { InfomodalComponent } from './dataPitcher/infomodal/infomodal.component';
import { AddcartComponent } from './dataPitcher/addcart/addcart.component';
import { QuickactionComponent } from './dataPitcher/quickaction/quickaction.component';
import { BillingComponent } from './dataPitcher/billing/billing.component';
import { EducationComponent } from './dataPitcher/education/education.component';
import { WalletComponent } from './dataPitcher/wallet/wallet.component';
import { FinancialComponent } from './dataPitcher/financial/financial.component';
import { UserinfoComponent } from './dataPitcher/userinfo/userinfo.component';
import { DeveloptoolComponent } from './dataPitcher/developtool/developtool.component';
import { DataserviceComponent } from './dataPitcher/dataservice/dataservice.component';
import { DatacompliancesComponent } from './dataPitcher/datacompliances/datacompliances.component';
import { DataofferingComponent } from './dataPitcher/dataoffering/dataoffering.component';
import { UpgradeplanComponent } from './dataPitcher/upgradeplan/upgradeplan.component';
import { LandingComponent } from './dataPitcher/landing/landing.component';
import { PurchaseComponent } from './dataPitcher/purchase/purchase.component';
import { PortfolioComponent } from './dataPitcher/portfolio/portfolio.component';
import { AlgoinfomodalComponent } from './dataPitcher/algoinfomodal/algoinfomodal.component';
import { SolinfomodalComponent } from './dataPitcher/solinfomodal/solinfomodal.component';
import { EnginfomodalComponent } from './dataPitcher/enginfomodal/enginfomodal.component';
import { CouponComponent } from './dataPitcher/coupon/coupon.component';
import { PurchasehistoryComponent } from './dataPitcher/purchasehistory/purchasehistory.component';


const appRoutes: Routes = [
  { path: '', component: LandingComponent },
  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'otpverify', component: OtpverifyComponent },
  { path: 'home', component: HomeComponent },
  { path: 'sell', component: SellComponent },
  { path: 'termcondition', component: TermconditionComponent },
  { path: 'asset', component: AssetComponent },
  { path: 'support', component: SupportComponent },
  { path: 'userprofile', component: UserprofileComponent },
  { path: 'algotermcondition', component: AlgotermconditionComponent },
  { path: 'enginetermcondition', component: EnginetermconditionComponent },
  { path: 'soltermcondition', component: SoltermconditionComponent },
  { path: 'algorithm', component:  AlgorithmComponent },
  { path: 'engine', component: EngineComponent },
  { path: 'solution', component: SolutionComponent },
  { path: 'purchase', component: PurchaseComponent },
  { path: 'billing', component: BillingComponent },
  { path: 'upgradeplan', component: UpgradeplanComponent },
  { path: 'dataoffering', component: DataofferingComponent },
  { path: 'dataservice', component: DataserviceComponent },
  { path: 'education', component: EducationComponent },
  { path: 'userinfo', component: UserinfoComponent },
  { path: 'wallet', component: WalletComponent},
  { path: 'addcart' , component: AddcartComponent},
  { path: 'datacompliances', component: DatacompliancesComponent },
  { path: 'portfolio', component: PortfolioComponent },
  { path: 'purchasehistory', component: PurchasehistoryComponent },
  ]

@NgModule({
  declarations: [
    AppComponent,
    SidemenuComponent,
    SellComponent,
    HomeComponent,
    SellheaderComponent,
    LoginComponent,
    TermconditionComponent,
    AssetComponent,
    RegisterComponent,
    OtpverifyComponent,
    SupportComponent,
    HelpComponent,
    UploadmodalComponent,
    NotificationComponent,
    ProfilemodalComponent,
    SellbuybuttonComponent,
    UserprofileComponent,
    AlgotermconditionComponent,
    EnginetermconditionComponent,
    SoltermconditionComponent,
    AlgorithmComponent,
    EngineComponent,
    SolutionComponent,
    StickytoolbarComponent,
    InfomodalComponent,
    AddcartComponent,
    QuickactionComponent,
    BillingComponent,
    EducationComponent,
    WalletComponent,
    FinancialComponent,
    UserinfoComponent,
    DeveloptoolComponent,
    DataserviceComponent,
    DatacompliancesComponent,
    DataofferingComponent,
    UpgradeplanComponent,
    LandingComponent,
    PurchaseComponent,
    PortfolioComponent,
    AlgoinfomodalComponent,
    SolinfomodalComponent,
    EnginfomodalComponent,
    CouponComponent,
    PurchasehistoryComponent
  ],
  imports: [
    NgbModule,
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    AngularMultiSelectModule,
    HttpClientModule,
    DatePickerModule,
    TagInputModule,
    NgxPaginationModule,
    AppRoutingModule,
    RouterModule.forRoot(appRoutes)
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
